import React from "react"
export function BahrainFlag(props) {
  return (
    <svg viewBox="0 0 24 16" {...props}>
      <g
        id="prefix__Double-Color-Icons"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <g id="prefix__Bahrain" fillRule="nonzero">
          <g id="prefix__bahrain">
            <path
              id="prefix__Rectangle"
              stroke="#CCC"
              strokeWidth={0.5}
              fill="#FFF"
              d="M.25.25h23.5v15.5H.25z"
            />
            <path
              id="prefix__Path"
              fill="#FF4B55"
              d="M6.6 0l3.3 1-3.3 1 3.3 1-3.3 1 3.3 1-3.3 1 3.3 1-3.3 1 3.3 1-3.3 1 3.3 1-3.3 1 3.3 1-3.3 1 3.3 1-3.3 1H24V0z"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}
